(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/*
 * @app ParishPages Pilot - St. Joan of Arc School
 * @author Piccirilli Dorsey, Inc.
 */

'use strict';

// modules

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _modulesMobileMenu = require('./modules/mobileMenu');

var _modulesMobileMenu2 = _interopRequireDefault(_modulesMobileMenu);

var _modulesDiocesePanel = require('./modules/diocesePanel');

var _modulesDiocesePanel2 = _interopRequireDefault(_modulesDiocesePanel);

var _modulesStickyHeader = require('./modules/stickyHeader');

var _modulesStickyHeader2 = _interopRequireDefault(_modulesStickyHeader);

var _modulesImageGallery = require('./modules/imageGallery');

var _modulesImageGallery2 = _interopRequireDefault(_modulesImageGallery);

var _modulesUi = require('./modules/ui');

var _modulesUi2 = _interopRequireDefault(_modulesUi);

var _modulesTabs = require('./modules/tabs');

var _modulesTabs2 = _interopRequireDefault(_modulesTabs);

var _modulesToggleShow = require('./modules/toggleShow');

var _modulesToggleShow2 = _interopRequireDefault(_modulesToggleShow);

var _modulesHero = require('./modules/hero');

var _modulesHero2 = _interopRequireDefault(_modulesHero);

var _modulesKey = require('./modules/key');

var _modulesKey2 = _interopRequireDefault(_modulesKey);

var _modulesClipboard = require('./modules/clipboard');

var _modulesClipboard2 = _interopRequireDefault(_modulesClipboard);

var _modulesRecaptcha = require('./modules/recaptcha');

var _modulesRecaptcha2 = _interopRequireDefault(_modulesRecaptcha);

var _modulesAnnouncements = require('./modules/announcements');

var _modulesAnnouncements2 = _interopRequireDefault(_modulesAnnouncements);

var _modulesMultisCheckbox = require('./modules/multisCheckbox');

var _modulesMultisCheckbox2 = _interopRequireDefault(_modulesMultisCheckbox);

// classes

var _classesCurrency = require('./classes/currency');

var _classesCurrency2 = _interopRequireDefault(_classesCurrency);

var _classesQuantity = require('./classes/quantity');

var _classesQuantity2 = _interopRequireDefault(_classesQuantity);

var app = {

    init: function init() {
        _modulesMobileMenu2['default'].init();
        _modulesDiocesePanel2['default'].init();
        _modulesStickyHeader2['default'].init();
        _modulesImageGallery2['default'].init();
        _modulesUi2['default'].init();
        _modulesTabs2['default'].init();
        _modulesToggleShow2['default'].init();
        _modulesHero2['default'].init();
        _modulesKey2['default'].init();
        _modulesClipboard2['default'].init();
        _modulesRecaptcha2['default'].init();
        _modulesAnnouncements2['default'].init();
        _modulesMultisCheckbox2['default'].init();
    }

};

// Call the initialize function
$(app.init);

},{"./classes/currency":5,"./classes/quantity":6,"./modules/announcements":8,"./modules/clipboard":9,"./modules/diocesePanel":10,"./modules/hero":11,"./modules/imageGallery":12,"./modules/key":13,"./modules/mobileMenu":14,"./modules/multisCheckbox":15,"./modules/recaptcha":16,"./modules/stickyHeader":17,"./modules/tabs":18,"./modules/toggleShow":19,"./modules/ui":20}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var $bodyHTML = $('body, html');

var Lightbox = (function () {
    function Lightbox($elem) {
        _classCallCheck(this, Lightbox);

        this.$elem = $elem;
        this.$close = this.$elem.find('.close');
        this.closeHandler();
    }

    _createClass(Lightbox, [{
        key: 'show',
        value: function show() {
            this.$elem.addClass('open');
            $bodyHTML.addClass('noscroll');
        }
    }, {
        key: 'hide',
        value: function hide() {
            var _this = this;

            this.$elem.addClass('out');
            $bodyHTML.removeClass('noscroll');

            setTimeout(function () {
                _this.$elem.removeClass('out open');
            }, 250);
        }
    }, {
        key: 'closeHandler',
        value: function closeHandler() {
            this.$close.on('click', this.hide.bind(this));
        }
    }]);

    return Lightbox;
})();

exports['default'] = Lightbox;
;
module.exports = exports['default'];

},{}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _helpersComputed = require('../helpers/computed');

var Slideshow = (function () {
    function Slideshow(config) {
        _classCallCheck(this, Slideshow);

        this.config = config;
        this.slideshow = config.el;

        this.showDots = (0, _helpersComputed.sliderDots)();
        this.hideDotsOnMobile = (0, _helpersComputed.hideDotsOnMobile)();

        this.start();
        this.listen();
    }

    _createClass(Slideshow, [{
        key: 'start',
        value: function start() {
            this.slick = this.slideshow.slick({
                dots: this.showDots,
                arrows: false,
                infinite: true,
                slide: '.slide',
                draggable: false,
                adaptiveHeight: true,
                autoplay: true,
                autoplaySpeed: 8000,
                pauseOnHover: false,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        dots: this.hideDotsOnMobile
                    }
                }]
            });
        }
    }, {
        key: 'listen',
        value: function listen() {
            var _this = this;

            this.config.next.click(function () {
                _this.slick.slick('slickNext');
                return false;
            });

            this.config.prev.click(function () {
                _this.slick.slick('slickPrev');
                return false;
            });
        }
    }]);

    return Slideshow;
})();

exports['default'] = Slideshow;
;
module.exports = exports['default'];

},{"../helpers/computed":7}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var ToggleShow = (function () {
    function ToggleShow($elem) {
        _classCallCheck(this, ToggleShow);

        this.$elem = $elem;
        this.$triggers = this.$elem.find('.c-toggle-show__trigger');
        this.$targets = this.$elem.find('.c-toggle-show__target');

        this.listeners();
    }

    _createClass(ToggleShow, [{
        key: 'listeners',
        value: function listeners() {
            this.$triggers.on('click', this.triggerClick.bind(this));
        }
    }, {
        key: 'triggerClick',
        value: function triggerClick(e) {
            var $elem = $(e.currentTarget);
            var target = $elem.data('target');

            if ($elem.hasClass('active')) {
                return false;
            }

            this.$triggers.removeClass('active');
            $elem.addClass('active');
            this.showTarget(target);

            return false;
        }
    }, {
        key: 'showTarget',
        value: function showTarget(selector) {
            var _this = this;

            var $target = $(selector);

            this.$targets.addClass('out');

            setTimeout(function () {
                _this.$targets.removeClass('out active');
                $target.addClass('active');
            }, 250);
        }
    }]);

    return ToggleShow;
})();

exports['default'] = ToggleShow;
;
module.exports = exports['default'];

},{}],5:[function(require,module,exports){
//
// Currency
//

'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var config = {
    currency: '.js-currency',
    presets: '.js-currency__preset',
    custom: '.js-currency__custom',
    total: '.js-currency__total'
};

var Currency = (function () {
    function Currency(_ref) {
        var currency = _ref.currency;

        _classCallCheck(this, Currency);

        this.$currency = currency;
        this.$presets = this.$currency.find(config.presets);
        this.$custom = this.$currency.find(config.custom);
        this.$total = this.$currency.find(config.total);

        this.initialize();

        this.events();

        Currency.initialized.push(this);
    }

    _createClass(Currency, [{
        key: 'initialize',
        value: function initialize() {
            this.$custom.on('input', function () {
                var val = this.value;
                var valid = /^\d{0,9}(\.\d{0,2})?$/.test(val);

                if (!valid) {
                    this.value = val.substring(0, val.length - 1);
                }
            });
        }
    }, {
        key: 'events',
        value: function events() {
            this.$presets.on('click', this.presetClick.bind(this));
            this.$custom.on('input change keydown keypress keyup mousedown click mouseup', this.customKeypress.bind(this));
        }
    }, {
        key: 'presetClick',
        value: function presetClick(e) {
            var $preset = $(e.currentTarget);
            var value = $preset.data('val');
            value = ('' + value).replace('$', '');

            this.mapValue(value);
            this.mapTotal(value);

            this.$presets.parent().removeClass('is-active');
            $preset.parent().addClass('is-active');

            return false;
        }
    }, {
        key: 'customKeypress',
        value: function customKeypress(e) {
            var value = this.$custom.val();

            this.$presets.parent().removeClass('is-active');
            this.$presets.filter('[data-val*="other"]').parent().addClass('is-active');

            this.mapTotal(value);
        }
    }, {
        key: 'mapValue',
        value: function mapValue(value) {
            if ($.isNumeric(value)) {
                this.$custom.val(value).trigger('change');
            } else {
                this.$custom.val('');
                this.$custom.focus();
            }
        }
    }, {
        key: 'mapTotal',
        value: function mapTotal(value) {
            if (!$.isNumeric(value) || value < 0) {
                value = 0;
            }

            value = parseFloat(value).toFixed(2);
            value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

            this.$total.text(value);
        }
    }]);

    return Currency;
})();

Currency.initialized = [];

// Driver
Currency.init = function () {
    var $Currency = $(config.currency);

    $Currency.each(function (index, elem) {
        var $Currency = $(elem);

        new Currency({
            currency: $Currency
        });
    });
};

$(function () {
    if (Currency.autoinit !== false) {
        Currency.init();
    }
});

exports['default'] = Currency;
module.exports = exports['default'];

},{}],6:[function(require,module,exports){
//
// Quantity
//

'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var config = {
    elem: '.js-quantity',
    price: '.js-quantity__price',
    quantity: '.js-quantity__quantity',
    total: '.js-quantity__total'
};

var Quantity = (function () {
    function Quantity(_ref) {
        var elem = _ref.elem;

        _classCallCheck(this, Quantity);

        this.$elem = elem;
        this.$price = this.$elem.find(config.price);
        this.$quantity = this.$elem.find(config.quantity);
        this.$total = this.$elem.find(config.total);

        this.price = this.$price.data('price');

        this.events();
    }

    _createClass(Quantity, [{
        key: 'events',
        value: function events() {
            this.$quantity.on('input change keydown keypress keyup mousedown click mouseup', this.quantityChange.bind(this));
        }
    }, {
        key: 'quantityChange',
        value: function quantityChange() {
            var quantity = this.$quantity.val();
            var total = this.price * quantity;

            this.changeTotal(total);
        }
    }, {
        key: 'changeTotal',
        value: function changeTotal(value) {
            value = parseFloat(value).toFixed(2);
            value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

            this.$total.text(value);
        }
    }]);

    return Quantity;
})();

Quantity.initialized = [];

// Driver
Quantity.init = function () {
    var $elems = $(config.elem);

    $elems.each(function (index, elem) {
        var $elem = $(elem);

        new Quantity({
            elem: $elem
        });
    });
};

$(function () {
    if (Quantity.autoinit !== false) {
        Quantity.init();
    }
});

exports['default'] = Quantity;
module.exports = exports['default'];

},{}],7:[function(require,module,exports){
'use strict';

/**
 * Computed Properties
 */
Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.hideDotsOnMobile = hideDotsOnMobile;
exports.sliderDots = sliderDots;
var HIDEONMOBILEDOTS = ['B', 'A'];

var STAGEDOTS = ['B', 'C', 'D'];

// Grab the config object from the Window
var config = window.PP;

function hideDotsOnMobile() {
  return HIDEONMOBILEDOTS.indexOf(config.stage) == -1;
}

function sliderDots() {
  return STAGEDOTS.indexOf(config.stage) !== -1;
}

},{}],8:[function(require,module,exports){
'use strict';

var announcements = {

    config: {
        wrapperClass: '.js-announcements',
        announcementClass: '.js-announcement',
        pagerClass: '.js-pager'
    },

    init: function init() {
        this.cacheDom();
        this.createSlideshow();
    },

    cacheDom: function cacheDom() {
        this.$wrapper = $(this.config.wrapperClass);
        this.$announcements = $(this.config.announcementClass);
        this.$pager = $(this.config.pagerClass);
    },

    createSlideshow: function createSlideshow() {

        this.$wrapper.slick({
            // adaptiveHeight: true,
            autoplay: true,
            autoplaySpeed: 5000,
            arrows: false,
            appendDots: this.$pager,
            dots: true,
            slide: this.config.announcementClass,
            swipe: true
        });
    }
};

module.exports = announcements;

},{}],9:[function(require,module,exports){
'use strict';

var clipboard = {

    init: function init() {
        new Clipboard('.c-button');
    }

};

module.exports = clipboard;

},{}],10:[function(require,module,exports){
'use strict';

var diocesePanel = {

    el: {
        top: $('#top'),
        tab: $('#top .diocese-tab'),
        button: $('.diocese-panel-close'),
        panel: $('#diocese-panel')
    },

    openOnFirstVisit: false,
    cookieName: 'diocese-panel-jan.25.2017',

    init: function init() {
        this.panelToggle();

        if (this.openOnFirstVisit) {
            this.openIfFirstVisit();
        }
    },

    panelToggle: function panelToggle() {
        var _this = this;
        this.el.tab.on('click', (function () {
            this.toggle();
        }).bind(this));
        this.el.button.on('click', (function () {
            this.close();
        }).bind(this));
    },

    toggle: function toggle() {
        this.el.panel.slideToggle('fast');
    },

    open: function open() {
        this.el.panel.slideDown('fast');
    },

    close: function close() {
        this.el.panel.slideUp('fast');
    },

    openIfFirstVisit: function openIfFirstVisit() {
        if (!this.getCookie(this.cookieName)) {
            this.open();
            this.setCookie(this.cookieName, 1, 30);
        }
    },

    setCookie: function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        var expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    },

    getCookie: function getCookie(cname) {
        var name = cname + '=';
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    }
};

module.exports = diocesePanel;

},{}],11:[function(require,module,exports){
'use strict';

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _classesSlideshow = require('../classes/Slideshow');

var _classesSlideshow2 = _interopRequireDefault(_classesSlideshow);

var hero = {

    el: {
        $slideshow: $('.slides'),
        $prev: $('.slide__left'),
        $next: $('.slide__right')
    },

    init: function init() {
        if (this.el.$slideshow.exists()) {
            this.slideshow();
        }
    },

    slideshow: function slideshow() {
        new _classesSlideshow2['default']({
            el: this.el.$slideshow,
            prev: this.el.$prev,
            next: this.el.$next
        });
    }

};

module.exports = hero;

},{"../classes/Slideshow":3}],12:[function(require,module,exports){
'use strict';

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _classesLightbox = require('../classes/Lightbox');

var _classesLightbox2 = _interopRequireDefault(_classesLightbox);

var imageGallery = {
    isInitialized: false,

    init: function init() {
        this.cacheDom();

        if (!this.$gallery.exists()) {
            return;
        }

        this.lightbox = new _classesLightbox2['default'](this.$lightbox);

        this.handlers();
    },

    cacheDom: function cacheDom() {
        this.$gallery = $('.c-image-gallery');
        this.$cycle = $('.c-cycle-slideshow__wrapper');
        this.$lightbox = $('.c-lightbox');

        this.$galleryHandle = this.$gallery.find('.c-image-gallery__gallery-handle');
        this.$cycleFigures = this.$cycle.find('.c-cycle-slideshow__image');

        this.$currentSlideLabel = $('.current-slide-label');
    },

    handlers: function handlers() {
        this.$galleryHandle.on('click', this.show.bind(this));
    },

    initialized: function initialized() {

        this.$cycleFigures.each(function (index, elem) {
            var $elem = $(elem).find('img');
            var src = $elem.data('lazy-load-src');

            $elem.attr('src', src);
        });

        this.$cycle.on('cycle-next', this.change.bind(this));
        this.$cycle.on('cycle-prev', this.change.bind(this));

        this.$cycle.cycle({
            speed: 500,
            manualSpeed: 500,
            log: false,
            loop: 1,
            next: '.next',
            pager: 'null',
            prev: '.prev',
            pauseOnHover: false,
            slideActiveClass: 'active',
            slides: 'figure',
            swipe: true
        }).cycle('pause');

        this.isInitialized = true;
    },

    change: function change(event, opts) {
        var $active = this.$cycleFigures.filter('.active');
        var slideNum = $active.data('num');

        this.$currentSlideLabel.html(slideNum);
    },

    show: function show() {
        if (!this.isInitialized) {
            this.initialized();
        }

        this.lightbox.show();
        return false;
    }
};

module.exports = imageGallery;

},{"../classes/Lightbox":2}],13:[function(require,module,exports){
'use strict';

var key = {
    init: function init() {
        this.cacheDom();

        if (!this.$keys.exists()) {
            return;
        }

        this.handlers();

        this.multiSelect = $('.c-calendar__filter select').multipleSelect({
            selectAll: false,
            multiple: false,
            placeholder: 'Categories',
            allSelected: 'Categories',

            onClick: function onClick(view) {
                var category = view.value;
                key.toggle(category);
            }
        });
    },

    cacheDom: function cacheDom() {
        this.$keys = $('.c-calendar__toolbars');
    },

    handlers: function handlers() {
        //
    },

    toggle: function toggle(category) {
        $('[data-category="' + category + '"').toggleClass('disabled');
    }
};

module.exports = key;

},{}],14:[function(require,module,exports){
'use strict';

var mobileMenu = {

    el: {
        menu: $('#mobile-nav'),
        menuOverlay: '#menu-overlay',
        menuOpenButton: $('#menu-toggle'),
        menuCloseButton: $('#menu-close')
    },

    init: function init() {
        this.menuOpenHandler();
        this.menuCloseHandler();
    },

    menuOpenHandler: function menuOpenHandler() {
        this.el.menuOpenButton.on('click', this.openMenu.bind(this));
    },

    menuCloseHandler: function menuCloseHandler() {
        this.el.menuCloseButton.on('click', this.closeMenu.bind(this));
    },

    openMenu: function openMenu() {
        this.el.menu.addClass('open');
        this.showMenuOverlay();
    },

    closeMenu: function closeMenu() {
        this.el.menu.addClass('out');
        this.hideMenuOverlay();

        setTimeout((function () {
            this.el.menu.removeClass('open out');
        }).bind(this), 250);
    },

    showMenuOverlay: function showMenuOverlay() {
        if (typeof this.el.$menuOverlay === 'undefined') {
            $('body').append('<div id="menu-overlay"></div>');
            this.el.$menuOverlay = $(this.el.menuOverlay);
            this.overlayClickHandler();
        }
        this.el.$menuOverlay.addClass('visible');
    },

    hideMenuOverlay: function hideMenuOverlay() {
        this.el.$menuOverlay.addClass('out');

        setTimeout((function () {
            this.el.$menuOverlay.removeClass('visible out');
        }).bind(this), 250);
    },

    overlayClickHandler: function overlayClickHandler() {
        this.el.$menuOverlay.on('click', this.closeMenu.bind(this));
    }
};

module.exports = mobileMenu;

},{}],15:[function(require,module,exports){
'use strict';

var ckeckboxInMulti = {
    init: function init() {
        if (window.location.href.indexOf("sjpmd") > -1) {
            $('form select[multiple]').multiselect();
        }
    }
};

module.exports = ckeckboxInMulti;

},{}],16:[function(require,module,exports){
'use strict';

var recaptcha = {

    init: function init() {
        this.cacheElems();

        if (!this.$wrapper.hasClass('has-recaptcha')) {
            return;
        }

        this.addVendorScript();
        this.addRecaptcha();
        this.events();
    },

    cacheElems: function cacheElems() {
        this.$wrapper = $('.c-form');
        this.$form = this.$wrapper.find('form');
        this.$fields = this.$form.find('.fields');
        this.$submit = this.$form.find('input[type="submit"]');
    },

    addVendorScript: function addVendorScript() {
        var scriptTag = document.createElement('script');
        scriptTag.type = 'text/javascript';
        scriptTag.src = 'https://www.google.com/recaptcha/api.js';

        (document.getElementsByTagName("head")[0] || document.documentElement).appendChild(scriptTag);
    },

    addRecaptcha: function addRecaptcha() {
        this.$fields.append('<div class="g-recaptcha" data-sitekey="6LeY6BgTAAAAANGbzIIYUO8Dcn6eYLLLu0BNjPWo"></div>');
        this.$gRecaptcha = $('.g-recaptcha');
    },

    events: function events() {
        // this.$form.on('submit', this.formSubmit.bind(this));
    },

    formSubmit: function formSubmit() {
        var gRecaptchaResponse = $('.g-recaptcha-response').val();

        $.post('actions/BusinessLogic/validateRecaptcha', {
            'g-recaptcha-response': gRecaptchaResponse
        }, (function (data) {
            if (!data.success) {
                this.$gRecaptcha.append('<span class="error">Not valid</span>');
                return;
            }

            this.$form.off();
            this.$form.submit();
        }).bind(this));

        return false;
    }
};

module.exports = recaptcha;

},{}],17:[function(require,module,exports){
'use strict';

var stickyHeader = {

    el: {
        header: $('#header')
    },

    init: function init() {
        this.makeSticky();
    },

    makeSticky: function makeSticky() {
        if ($(window).width() < 768) {
            this.el.header.headroom({
                offset: 100,
                tolerance: 10,
                classes: {
                    initial: 'animated',
                    pinned: 'slideDown',
                    unpinned: 'slideUp'
                }
            });
        }
    }
};

module.exports = stickyHeader;

},{}],18:[function(require,module,exports){
'use strict';

var tabs = {

    el: {
        tabs: $('.c-tabs__list li'),
        panels: $('.c-tabs__content .content-panel')
    },

    vars: {
        activeClass: 'active'
    },

    init: function init() {
        this.tabClickHandler();
    },

    tabClickHandler: function tabClickHandler() {
        var _this = this;
        var a = this.vars.activeClass;

        // Tab Click Event
        this.el.tabs.find('a').on('click', function (e) {
            e.preventDefault();

            // Reset
            _this.resetTabs();
            _this.resetPanels();

            // Activate target panel and current tab
            var targetPanel = $(this).data('target');
            $(targetPanel).addClass(_this.vars.activeClass);
            $(this).parent().addClass(_this.vars.activeClass);
        });
    },

    resetTabs: function resetTabs() {
        this.el.tabs.removeClass(this.vars.activeClass);
    },

    resetPanels: function resetPanels() {
        this.el.panels.removeClass(this.vars.activeClass);
    }
};

module.exports = tabs;

},{}],19:[function(require,module,exports){
'use strict';

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _classesToggleShow = require('../classes/ToggleShow');

var _classesToggleShow2 = _interopRequireDefault(_classesToggleShow);

var toggleShow = {

    init: function init() {
        this.$elems = $('.c-toggle-show');

        this.$elems.each(function (index, elem) {
            new _classesToggleShow2['default']($(elem));
        });
    }
};

module.exports = toggleShow;

},{"../classes/ToggleShow":4}],20:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
exports['default'] = {

    init: function init() {
        // open external links in new tab
        this.externalLinks();

        // open PDFs in a new tab
        this.pdfLinks();

        // add '...' to overflowing breadcrumbs on smaller breakpoints
        this.trunCrumb.init();

        // removes image height + width given by redactor
        this.inlineImages();

        // adds responsive class around embeds
        this.responsiveEmbeds();

        // removes darker active class on sidebar elements with hidden children
        this.sidebarGrandchildActive();

        // Toggles the searchbar
        this.searchToggle();

        // Displays Inline Popup
        this.popup();

        // Diocese panel logic to display on first visit
        this.diocesePanel.init();

        // replace pipe chatacters with a span divider.
        this.pipeReplace();
    },

    externalLinks: function externalLinks() {
        $('a').each(function () {
            var a = new RegExp('/' + window.location.host + '/');
            if (!a.test(this.href) && this.href.indexOf('javascript') == -1) {
                $(this).addClass('external');
                $(this).prop('target', '_blank');
            }
        });
    },

    pdfLinks: function pdfLinks() {
        $('a').each(function () {
            if (this.href.indexOf('.pdf') > -1) {
                $(this).addClass('pdf');
                $(this).prop('target', '_blank');
            }
        });
    },

    trunCrumb: {
        init: function init() {
            this.cacheDom();

            this.breadWidth = this.$breadCrumb.width();
            this.breadHeight = this.$breadCrumb.height();
            this.firstLiHeight = this.$firstLi.height();

            if (this.breadHeight > this.firstLiHeight) {
                this.trunc();
            }
        },

        cacheDom: function cacheDom() {
            this.$breadCrumb = $('.c-breadcrumbs');
            this.$lis = this.$breadCrumb.find('li');
            this.$firstLi = this.$lis.first();
            this.$lastLi = this.$lis.last();
        },

        trunc: function trunc() {
            var $allLisExceptLast = this.$lis.not(this.$lastLi);
            var totalWidth = 0;

            $allLisExceptLast.each(function (index, elem) {
                var $elem = $(elem);
                var width = $elem.width();

                totalWidth += width;
            });

            // width of before element + some leeway
            totalWidth += 19 + 3;

            var lastLiWidth = this.breadWidth - totalWidth;

            this.$lastLi.find('span').css('width', lastLiWidth + 'px');
        }
    },

    inlineImages: function inlineImages() {
        $('.image-left, .image-right, .image-center, .signature').each(function (index, elem) {
            var $elem = $(elem);

            $elem.removeAttr('style height width');
        });
    },

    responsiveEmbeds: function responsiveEmbeds() {
        var $embeds = $('.main-content iframe');

        if (!$embeds.exists()) {
            return;
        }

        if ($embeds.hasClass('no-respond')) {
            return;
        }

        $embeds.each(function (index, elem) {
            var $elem = $(elem);
            var $parent = $elem.parent();
            var wrap = '<div class="c-embed"></div>';

            if ($parent.hasClass('c-embed')) {
                return true; // continue
            }

            $elem.removeAttr('style height width');
            $elem.addClass('c-embed__item');
            $elem.wrap(wrap);
        });
    },

    sidebarGrandchildActive: function sidebarGrandchildActive() {
        $('.child-navigation li:has(li:not(.active))').addClass('has-subnav');
    },

    searchToggle: function searchToggle() {
        var searchActivator = $('.search-activator');
        var searchComponent = $('.c-search');
        var searchInput = $('.main-search');

        searchActivator.click(function () {
            searchComponent.toggleClass('active');
            if (searchComponent.hasClass('active')) {
                searchInput.focus();
            } else {
                searchInput.blur();
            }
        });
    },

    popup: function popup() {
        $('.open-popup-link').magnificPopup({
            type: 'inline',
            midClick: true,
            alignTop: false,
            mainClass: 'active',
            removalDelay: 250
        });

        $('.c-calendar table ul a, .event-item, .js-event-popup').magnificPopup({
            type: 'ajax',
            midClick: true,
            alignTop: false,
            mainClass: 'active',
            removalDelay: 250
        });
    },

    diocesePanel: {
        init: function init() {
            this.$panel = $('#diocese-panel');
            this.showOnVisit = this.$panel.data('show-on-visit');

            if (!this.showOnVisit) {
                return;
            }

            if (this.isFirstVisit()) {
                this.show();
                this.setCookie();
            }
        },

        isFirstVisit: function isFirstVisit() {
            return Cookies.get('has-visited') == undefined;
        },

        show: function show() {
            this.$panel.addClass('is-open');
        },

        setCookie: function setCookie() {
            Cookies.set('has-visited', '1', {
                expires: 604800 // expire in a week
            });
        }
    },
    pipeReplace: function pipeReplace() {
        var $input = $('.c-tabs__content h2, .tab-content h2');

        if (!$input.exists()) {
            return;
        }

        if (!PP.infoTabs == 'B' && !PP.infoTabs == 'E') {
            return;
        }

        $input.each(function (index, elem) {
            var $elem = $(elem);
            var $inputString = $elem.html();
            var output = $inputString.replace(/\|/g, '<span class="divider">&nbsp;</span>');
            $elem.html(output);
        });
    }
};
module.exports = exports['default'];

},{}]},{},[1]);
